module.exports = __webpack_public_path__ + "img/compras100pe.2f5770a7.jpg";